// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm from "./buhta_kassa_v1alpha1_kkm.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  3699,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  3762,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetRunningBalanceRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  3822,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetRunningBalanceResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  3913,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RunningBalance"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListKkmsRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4037,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListKkmsResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4097,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4188,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4312,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4440,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmData"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmPreferencesData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4651,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const StartKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4711,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const StartKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4771,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const RegisterKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4832,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const RegisterKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4895,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ChangeRegisterKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4956,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ChangeRegisterKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5019,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const KkmInisData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5088,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UnregisterKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5200,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmUnregisterData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UnregisterKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5323,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const LinkKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5414,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const LinkKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5537,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ActivateKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5597,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ActivateKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5657,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ConnectKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5748,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmConnectData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ConnectKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5871,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const OfdCredentials = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5932,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DeleteKkmRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5995,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DeleteKkmResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  6053,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.kassa.v1alpha1.GetKkmRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    id: id,
    expand: expand
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    2,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      2,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetKkmRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetKkmRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetKkmRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.kassa.v1alpha1.GetKkmResponse";
}

function make$1(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm, t1.kkm, t2.kkm)
  };
}

function spec$1(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.kkm);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetKkmResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$3(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetKkmResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetKkmResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.kassa.v1alpha1.GetRunningBalanceRequest";
}

function make$2(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id
  };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

function merge$2(t1, t2) {
  return {
    id: Curry._2(merge_id$1, t1.id, t2.id)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.id);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(id) {
  return {
    id: id
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetRunningBalanceRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$5(id) {
  return {
    id: id
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetRunningBalanceRequest", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetRunningBalanceRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

const RunningBalance = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  3945,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$3(param) {
  return ".buhta.kassa.v1alpha1.GetRunningBalanceResponse.RunningBalance";
}

function make$3(available_cashOpt, revenueOpt, param) {
  const available_cash = available_cashOpt !== undefined ? available_cashOpt : "";
  const revenue = revenueOpt !== undefined ? revenueOpt : "";
  return {
    available_cash: available_cash,
    revenue: revenue
  };
}

const merge_available_cash = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "available_cash",
    "availableCash"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_revenue = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "revenue",
    "revenue"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$3(t1, t2) {
  return {
    available_cash: Curry._2(merge_available_cash, t1.available_cash, t2.available_cash),
    revenue: Curry._2(merge_revenue, t1.revenue, t2.revenue)
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "available_cash",
      "availableCash"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "revenue",
      "revenue"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.available_cash, param.revenue);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(available_cash, revenue) {
  return {
    available_cash: available_cash,
    revenue: revenue
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetRunningBalanceResponse.RunningBalance", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.available_cash, param.revenue);
  };
}

function constructor$7(available_cash, revenue) {
  return {
    available_cash: available_cash,
    revenue: revenue
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetRunningBalanceResponse.RunningBalance", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, RunningBalance, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.kassa.v1alpha1.GetRunningBalanceResponse";
}

function make$4(balance, param) {
  return {
    balance: balance
  };
}

const merge_balance = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "balance",
    "balance"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: RunningBalance.name,
    make: RunningBalance.make,
    from_proto: RunningBalance.from_proto,
    from_proto_exn: RunningBalance.from_proto_exn,
    to_proto: RunningBalance.to_proto,
    to_proto$p: RunningBalance.to_proto$p,
    merge: RunningBalance.merge,
    to_json: RunningBalance.to_json,
    from_json_exn: RunningBalance.from_json_exn,
    from_json: RunningBalance.from_json
  })
]));

function merge$4(t1, t2) {
  return {
    balance: Curry._2(merge_balance, t1.balance, t2.balance)
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "balance",
      "balance"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: RunningBalance.name,
      make: RunningBalance.make,
      from_proto: RunningBalance.from_proto,
      from_proto_exn: RunningBalance.from_proto_exn,
      to_proto: RunningBalance.to_proto,
      to_proto$p: RunningBalance.to_proto$p,
      merge: RunningBalance.merge,
      to_json: RunningBalance.to_json,
      from_json_exn: RunningBalance.from_json_exn,
      from_json: RunningBalance.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.balance);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(balance) {
  return {
    balance: balance
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetRunningBalanceResponse", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.balance);
  };
}

function constructor$9(balance) {
  return {
    balance: balance
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetRunningBalanceResponse", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RunningBalance"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetRunningBalanceResponse, {
  RunningBalance: RunningBalance,
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.kassa.v1alpha1.ListKkmsRequest";
}

function make$5(grid, param) {
  return {
    grid: grid
  };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "grid",
    "grid"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    grid: Curry._2(merge_grid, t1.grid, t2.grid)
  };
}

function spec$5(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "grid",
      "grid"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.grid);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(grid) {
  return {
    grid: grid
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListKkmsRequest", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$11(grid) {
  return {
    grid: grid
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListKkmsRequest", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListKkmsRequest, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.kassa.v1alpha1.ListKkmsResponse";
}

function make$6(kkmsOpt, param) {
  const kkms = kkmsOpt !== undefined ? kkmsOpt : /* [] */ 0;
  return {
    kkms: kkms
  };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkms = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "kkms",
    "kkms"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$6(t1, t2) {
  return {
    kkms: Curry._2(merge_kkms, t1.kkms, t2.kkms)
  };
}

function spec$6(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "kkms",
      "kkms"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.kkms);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(kkms) {
  return {
    kkms: kkms
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListKkmsResponse", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkms);
  };
}

function constructor$13(kkms) {
  return {
    kkms: kkms
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListKkmsResponse", spec$6(undefined), constructor$13);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListKkmsResponse, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

const KkmData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4220,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$7(param) {
  return ".buhta.kassa.v1alpha1.CreateKkmRequest.KkmData";
}

function make$7(ofd_provider_idOpt, nameOpt, param) {
  const ofd_provider_id = ofd_provider_idOpt !== undefined ? ofd_provider_idOpt : 0;
  const name = nameOpt !== undefined ? nameOpt : "";
  return {
    ofd_provider_id: ofd_provider_id,
    name: name
  };
}

const merge_ofd_provider_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "ofd_provider_id",
    "ofdProviderId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$7(t1, t2) {
  return {
    ofd_provider_id: Curry._2(merge_ofd_provider_id, t1.ofd_provider_id, t2.ofd_provider_id),
    name: Curry._2(merge_name, t1.name, t2.name)
  };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "ofd_provider_id",
      "ofdProviderId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.ofd_provider_id, param.name);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(ofd_provider_id, name) {
  return {
    ofd_provider_id: ofd_provider_id,
    name: name
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateKkmRequest.KkmData", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.ofd_provider_id, param.name);
  };
}

function constructor$15(ofd_provider_id, name) {
  return {
    ofd_provider_id: ofd_provider_id,
    name: name
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateKkmRequest.KkmData", spec$7(undefined), constructor$15);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmData, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

function name$8(param) {
  return ".buhta.kassa.v1alpha1.CreateKkmRequest";
}

function make$8(kkm, param) {
  return {
    kkm: kkm
  };
}

const merge_kkm$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmData.name,
    make: KkmData.make,
    from_proto: KkmData.from_proto,
    from_proto_exn: KkmData.from_proto_exn,
    to_proto: KkmData.to_proto,
    to_proto$p: KkmData.to_proto$p,
    merge: KkmData.merge,
    to_json: KkmData.to_json,
    from_json_exn: KkmData.from_json_exn,
    from_json: KkmData.from_json
  })
]));

function merge$8(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$1, t1.kkm, t2.kkm)
  };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmData.name,
      make: KkmData.make,
      from_proto: KkmData.from_proto,
      from_proto_exn: KkmData.from_proto_exn,
      to_proto: KkmData.to_proto,
      to_proto$p: KkmData.to_proto$p,
      merge: KkmData.merge,
      to_json: KkmData.to_json,
      from_json_exn: KkmData.from_json_exn,
      from_json: KkmData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.kkm);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateKkmRequest", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$17(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateKkmRequest", spec$8(undefined), constructor$17);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateKkmRequest, {
  KkmData: KkmData,
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".buhta.kassa.v1alpha1.CreateKkmResponse";
}

function make$9(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$9(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$2, t1.kkm, t2.kkm)
  };
}

function spec$9(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
});

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.kkm);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateKkmResponse", spec$9(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$19(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateKkmResponse", spec$9(undefined), constructor$19);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateKkmResponse, {
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

const KkmData$1 = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4472,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const KkmPreferencesData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  4541,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$10(param) {
  return ".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmData";
}

function make$10(nameOpt, preferences, param) {
  const name = nameOpt !== undefined ? nameOpt : "";
  return {
    name: name,
    preferences: preferences
  };
}

const merge_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_preferences = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "preferences",
    "preferences"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmPreferencesData.name,
    make: KkmPreferencesData.make,
    from_proto: KkmPreferencesData.from_proto,
    from_proto_exn: KkmPreferencesData.from_proto_exn,
    to_proto: KkmPreferencesData.to_proto,
    to_proto$p: KkmPreferencesData.to_proto$p,
    merge: KkmPreferencesData.merge,
    to_json: KkmPreferencesData.to_json,
    from_json_exn: KkmPreferencesData.from_json_exn,
    from_json: KkmPreferencesData.from_json
  })
]));

function merge$10(t1, t2) {
  return {
    name: Curry._2(merge_name$1, t1.name, t2.name),
    preferences: Curry._2(merge_preferences, t1.preferences, t2.preferences)
  };
}

function spec$10(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "preferences",
      "preferences"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmPreferencesData.name,
      make: KkmPreferencesData.make,
      from_proto: KkmPreferencesData.from_proto,
      from_proto_exn: KkmPreferencesData.from_proto_exn,
      to_proto: KkmPreferencesData.to_proto,
      to_proto$p: KkmPreferencesData.to_proto$p,
      merge: KkmPreferencesData.merge,
      to_json: KkmPreferencesData.to_json,
      from_json_exn: KkmPreferencesData.from_json_exn,
      from_json: KkmPreferencesData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$10(undefined));
});

function to_proto$p$10(writer, param) {
  Curry._3(serialize$10, writer, param.name, param.preferences);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$10(writer, t);
  return writer;
}

function constructor$20(name, preferences) {
  return {
    name: name,
    preferences: preferences
  };
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$10(undefined), constructor$20);
});

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$10, writer);
  });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmData", spec$10(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.name, param.preferences);
  };
}

function constructor$21(name, preferences) {
  return {
    name: name,
    preferences: preferences
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmData", spec$10(undefined), constructor$21);
});

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$10, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmData$1, {
  make: make$10,
  to_proto: to_proto$10,
  from_proto: from_proto$10,
  to_json: to_json$10,
  from_json: from_json$10,
  name: name$10,
  merge: merge$10,
  to_proto$p: to_proto$p$10,
  from_proto_exn: from_proto_exn$10,
  from_json_exn: from_json_exn$10
});

function name$11(param) {
  return ".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmPreferencesData";
}

function make$11(allow_autoclose_shiftOpt, allow_autoclose_withdrawOpt, allow_autotaxOpt, allow_ui_salesOpt, allow_ui_markup_discountOpt, default_domainOpt, receipt_langOpt, param) {
  const allow_autoclose_shift = allow_autoclose_shiftOpt !== undefined ? allow_autoclose_shiftOpt : false;
  const allow_autoclose_withdraw = allow_autoclose_withdrawOpt !== undefined ? allow_autoclose_withdrawOpt : false;
  const allow_autotax = allow_autotaxOpt !== undefined ? allow_autotaxOpt : false;
  const allow_ui_sales = allow_ui_salesOpt !== undefined ? allow_ui_salesOpt : false;
  const allow_ui_markup_discount = allow_ui_markup_discountOpt !== undefined ? allow_ui_markup_discountOpt : false;
  const default_domain = default_domainOpt !== undefined ? default_domainOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0);
  const receipt_lang = receipt_langOpt !== undefined ? receipt_langOpt : "";
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const merge_allow_autoclose_shift = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "allow_autoclose_shift",
    "allowAutocloseShift"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_autoclose_withdraw = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "allow_autoclose_withdraw",
    "allowAutocloseWithdraw"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_autotax = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "allow_autotax",
    "allowAutotax"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_sales = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "allow_ui_sales",
    "allowUiSales"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_markup_discount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "allow_ui_markup_discount",
    "allowUiMarkupDiscount"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_default_domain = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "default_domain",
    "defaultDomain"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
]));

const merge_receipt_lang = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    7,
    "receipt_lang",
    "receiptLang"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$11(t1, t2) {
  return {
    allow_autoclose_shift: Curry._2(merge_allow_autoclose_shift, t1.allow_autoclose_shift, t2.allow_autoclose_shift),
    allow_autoclose_withdraw: Curry._2(merge_allow_autoclose_withdraw, t1.allow_autoclose_withdraw, t2.allow_autoclose_withdraw),
    allow_autotax: Curry._2(merge_allow_autotax, t1.allow_autotax, t2.allow_autotax),
    allow_ui_sales: Curry._2(merge_allow_ui_sales, t1.allow_ui_sales, t2.allow_ui_sales),
    allow_ui_markup_discount: Curry._2(merge_allow_ui_markup_discount, t1.allow_ui_markup_discount, t2.allow_ui_markup_discount),
    default_domain: Curry._2(merge_default_domain, t1.default_domain, t2.default_domain),
    receipt_lang: Curry._2(merge_receipt_lang, t1.receipt_lang, t2.receipt_lang)
  };
}

function spec$11(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "allow_autoclose_shift",
      "allowAutocloseShift"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "allow_autoclose_withdraw",
      "allowAutocloseWithdraw"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "allow_autotax",
      "allowAutotax"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "allow_ui_sales",
      "allowUiSales"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "allow_ui_markup_discount",
      "allowUiMarkupDiscount"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "default_domain",
      "defaultDomain"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
    Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      7,
      "receipt_lang",
      "receiptLang"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$11(undefined));
});

function to_proto$p$11(writer, param) {
  Curry._8(serialize$11, writer, param.allow_autoclose_shift, param.allow_autoclose_withdraw, param.allow_autotax, param.allow_ui_sales, param.allow_ui_markup_discount, param.default_domain, param.receipt_lang);
}

function to_proto$11(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$11(writer, t);
  return writer;
}

function constructor$22(allow_autoclose_shift, allow_autoclose_withdraw, allow_autotax, allow_ui_sales, allow_ui_markup_discount, default_domain, receipt_lang) {
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const from_proto_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$11(undefined), constructor$22);
});

function from_proto$11(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$11, writer);
  });
}

function to_json$11(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmPreferencesData", spec$11(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.allow_autoclose_shift, param.allow_autoclose_withdraw, param.allow_autotax, param.allow_ui_sales, param.allow_ui_markup_discount, param.default_domain, param.receipt_lang);
  };
}

function constructor$23(allow_autoclose_shift, allow_autoclose_withdraw, allow_autotax, allow_ui_sales, allow_ui_markup_discount, default_domain, receipt_lang) {
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const from_json_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateKkmRequest.KkmPreferencesData", spec$11(undefined), constructor$23);
});

function from_json$11(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$11, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmPreferencesData, {
  make: make$11,
  to_proto: to_proto$11,
  from_proto: from_proto$11,
  to_json: to_json$11,
  from_json: from_json$11,
  name: name$11,
  merge: merge$11,
  to_proto$p: to_proto$p$11,
  from_proto_exn: from_proto_exn$11,
  from_json_exn: from_json_exn$11
});

function name$12(param) {
  return ".buhta.kassa.v1alpha1.UpdateKkmRequest";
}

function make$12(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmData$1.name,
    make: KkmData$1.make,
    from_proto: KkmData$1.from_proto,
    from_proto_exn: KkmData$1.from_proto_exn,
    to_proto: KkmData$1.to_proto,
    to_proto$p: KkmData$1.to_proto$p,
    merge: KkmData$1.merge,
    to_json: KkmData$1.to_json,
    from_json_exn: KkmData$1.from_json_exn,
    from_json: KkmData$1.from_json
  })
]));

function merge$12(t1, t2) {
  return {
    id: Curry._2(merge_id$2, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$3, t1.kkm, t2.kkm)
  };
}

function spec$12(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmData$1.name,
      make: KkmData$1.make,
      from_proto: KkmData$1.from_proto,
      from_proto_exn: KkmData$1.from_proto_exn,
      to_proto: KkmData$1.to_proto,
      to_proto$p: KkmData$1.to_proto$p,
      merge: KkmData$1.merge,
      to_json: KkmData$1.to_json,
      from_json_exn: KkmData$1.from_json_exn,
      from_json: KkmData$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$12(undefined));
});

function to_proto$p$12(writer, param) {
  Curry._3(serialize$12, writer, param.id, param.kkm);
}

function to_proto$12(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$12(writer, t);
  return writer;
}

function constructor$24(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$12(undefined), constructor$24);
});

function from_proto$12(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$12, writer);
  });
}

function to_json$12(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateKkmRequest", spec$12(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$25(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateKkmRequest", spec$12(undefined), constructor$25);
});

function from_json$12(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$12, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmData"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmPreferencesData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateKkmRequest, {
  KkmData: KkmData$1,
  KkmPreferencesData: KkmPreferencesData,
  make: make$12,
  to_proto: to_proto$12,
  from_proto: from_proto$12,
  to_json: to_json$12,
  from_json: from_json$12,
  name: name$12,
  merge: merge$12,
  to_proto$p: to_proto$p$12,
  from_proto_exn: from_proto_exn$12,
  from_json_exn: from_json_exn$12
});

function name$13(param) {
  return ".buhta.kassa.v1alpha1.UpdateKkmResponse";
}

function make$13(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$13(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$4, t1.kkm, t2.kkm)
  };
}

function spec$13(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$13(undefined));
});

function to_proto$p$13(writer, param) {
  Curry._2(serialize$13, writer, param.kkm);
}

function to_proto$13(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$13(writer, t);
  return writer;
}

function constructor$26(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$13(undefined), constructor$26);
});

function from_proto$13(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$13, writer);
  });
}

function to_json$13(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateKkmResponse", spec$13(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$27(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateKkmResponse", spec$13(undefined), constructor$27);
});

function from_json$13(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$13, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateKkmResponse, {
  make: make$13,
  to_proto: to_proto$13,
  from_proto: from_proto$13,
  to_json: to_json$13,
  from_json: from_json$13,
  name: name$13,
  merge: merge$13,
  to_proto$p: to_proto$p$13,
  from_proto_exn: from_proto_exn$13,
  from_json_exn: from_json_exn$13
});

function name$14(param) {
  return ".buhta.kassa.v1alpha1.StartKkmRequest";
}

function make$14(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id
  };
}

const merge_id$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

function merge$14(t1, t2) {
  return {
    id: Curry._2(merge_id$3, t1.id, t2.id)
  };
}

function spec$14(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$14(undefined));
});

function to_proto$p$14(writer, param) {
  Curry._2(serialize$14, writer, param.id);
}

function to_proto$14(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$14(writer, t);
  return writer;
}

function constructor$28(id) {
  return {
    id: id
  };
}

const from_proto_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$14(undefined), constructor$28);
});

function from_proto$14(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$14, writer);
  });
}

function to_json$14(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.StartKkmRequest", spec$14(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$29(id) {
  return {
    id: id
  };
}

const from_json_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.StartKkmRequest", spec$14(undefined), constructor$29);
});

function from_json$14(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$14, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, StartKkmRequest, {
  make: make$14,
  to_proto: to_proto$14,
  from_proto: from_proto$14,
  to_json: to_json$14,
  from_json: from_json$14,
  name: name$14,
  merge: merge$14,
  to_proto$p: to_proto$p$14,
  from_proto_exn: from_proto_exn$14,
  from_json_exn: from_json_exn$14
});

function name$15(param) {
  return ".buhta.kassa.v1alpha1.StartKkmResponse";
}

function make$15(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$5 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$5 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

function merge$15(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$5, t1.kkm, t2.kkm)
  };
}

function spec$15(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$15(undefined));
});

function to_proto$p$15(writer, param) {
  Curry._2(serialize$15, writer, param.kkm);
}

function to_proto$15(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$15(writer, t);
  return writer;
}

function constructor$30(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$15(undefined), constructor$30);
});

function from_proto$15(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$15, writer);
  });
}

function to_json$15(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.StartKkmResponse", spec$15(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$31(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.StartKkmResponse", spec$15(undefined), constructor$31);
});

function from_json$15(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$15, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, StartKkmResponse, {
  make: make$15,
  to_proto: to_proto$15,
  from_proto: from_proto$15,
  to_json: to_json$15,
  from_json: from_json$15,
  name: name$15,
  merge: merge$15,
  to_proto$p: to_proto$p$15,
  from_proto_exn: from_proto_exn$15,
  from_json_exn: from_json_exn$15
});

function name$16(param) {
  return ".buhta.kassa.v1alpha1.RegisterKkmRequest";
}

function make$16(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$6 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmInisData.name,
    make: KkmInisData.make,
    from_proto: KkmInisData.from_proto,
    from_proto_exn: KkmInisData.from_proto_exn,
    to_proto: KkmInisData.to_proto,
    to_proto$p: KkmInisData.to_proto$p,
    merge: KkmInisData.merge,
    to_json: KkmInisData.to_json,
    from_json_exn: KkmInisData.from_json_exn,
    from_json: KkmInisData.from_json
  })
]));

function merge$16(t1, t2) {
  return {
    id: Curry._2(merge_id$4, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$6, t1.kkm, t2.kkm)
  };
}

function spec$16(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmInisData.name,
      make: KkmInisData.make,
      from_proto: KkmInisData.from_proto,
      from_proto_exn: KkmInisData.from_proto_exn,
      to_proto: KkmInisData.to_proto,
      to_proto$p: KkmInisData.to_proto$p,
      merge: KkmInisData.merge,
      to_json: KkmInisData.to_json,
      from_json_exn: KkmInisData.from_json_exn,
      from_json: KkmInisData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$16(undefined));
});

function to_proto$p$16(writer, param) {
  Curry._3(serialize$16, writer, param.id, param.kkm);
}

function to_proto$16(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$16(writer, t);
  return writer;
}

function constructor$32(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$16(undefined), constructor$32);
});

function from_proto$16(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$16, writer);
  });
}

function to_json$16(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.RegisterKkmRequest", spec$16(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$33(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.RegisterKkmRequest", spec$16(undefined), constructor$33);
});

function from_json$16(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$16, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, RegisterKkmRequest, {
  make: make$16,
  to_proto: to_proto$16,
  from_proto: from_proto$16,
  to_json: to_json$16,
  from_json: from_json$16,
  name: name$16,
  merge: merge$16,
  to_proto$p: to_proto$p$16,
  from_proto_exn: from_proto_exn$16,
  from_json_exn: from_json_exn$16
});

function name$17(param) {
  return ".buhta.kassa.v1alpha1.RegisterKkmResponse";
}

function make$17(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$6 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$7 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

function merge$17(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$7, t1.kkm, t2.kkm)
  };
}

function spec$17(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$17(undefined));
});

function to_proto$p$17(writer, param) {
  Curry._2(serialize$17, writer, param.kkm);
}

function to_proto$17(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$17(writer, t);
  return writer;
}

function constructor$34(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$17(undefined), constructor$34);
});

function from_proto$17(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$17, writer);
  });
}

function to_json$17(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.RegisterKkmResponse", spec$17(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$35(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.RegisterKkmResponse", spec$17(undefined), constructor$35);
});

function from_json$17(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$17, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, RegisterKkmResponse, {
  make: make$17,
  to_proto: to_proto$17,
  from_proto: from_proto$17,
  to_json: to_json$17,
  from_json: from_json$17,
  name: name$17,
  merge: merge$17,
  to_proto$p: to_proto$p$17,
  from_proto_exn: from_proto_exn$17,
  from_json_exn: from_json_exn$17
});

function name$18(param) {
  return ".buhta.kassa.v1alpha1.ChangeRegisterKkmRequest";
}

function make$18(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$5 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$8 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmInisData.name,
    make: KkmInisData.make,
    from_proto: KkmInisData.from_proto,
    from_proto_exn: KkmInisData.from_proto_exn,
    to_proto: KkmInisData.to_proto,
    to_proto$p: KkmInisData.to_proto$p,
    merge: KkmInisData.merge,
    to_json: KkmInisData.to_json,
    from_json_exn: KkmInisData.from_json_exn,
    from_json: KkmInisData.from_json
  })
]));

function merge$18(t1, t2) {
  return {
    id: Curry._2(merge_id$5, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$8, t1.kkm, t2.kkm)
  };
}

function spec$18(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmInisData.name,
      make: KkmInisData.make,
      from_proto: KkmInisData.from_proto,
      from_proto_exn: KkmInisData.from_proto_exn,
      to_proto: KkmInisData.to_proto,
      to_proto$p: KkmInisData.to_proto$p,
      merge: KkmInisData.merge,
      to_json: KkmInisData.to_json,
      from_json_exn: KkmInisData.from_json_exn,
      from_json: KkmInisData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$18(undefined));
});

function to_proto$p$18(writer, param) {
  Curry._3(serialize$18, writer, param.id, param.kkm);
}

function to_proto$18(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$18(writer, t);
  return writer;
}

function constructor$36(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$18(undefined), constructor$36);
});

function from_proto$18(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$18, writer);
  });
}

function to_json$18(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ChangeRegisterKkmRequest", spec$18(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$37(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ChangeRegisterKkmRequest", spec$18(undefined), constructor$37);
});

function from_json$18(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$18, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ChangeRegisterKkmRequest, {
  make: make$18,
  to_proto: to_proto$18,
  from_proto: from_proto$18,
  to_json: to_json$18,
  from_json: from_json$18,
  name: name$18,
  merge: merge$18,
  to_proto$p: to_proto$p$18,
  from_proto_exn: from_proto_exn$18,
  from_json_exn: from_json_exn$18
});

function name$19(param) {
  return ".buhta.kassa.v1alpha1.ChangeRegisterKkmResponse";
}

function make$19(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$7 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$9 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$7.name,
    make: $$let$7.make,
    from_proto: $$let$7.from_proto,
    from_proto_exn: $$let$7.from_proto_exn,
    to_proto: $$let$7.to_proto,
    to_proto$p: $$let$7.to_proto$p,
    merge: $$let$7.merge,
    to_json: $$let$7.to_json,
    from_json_exn: $$let$7.from_json_exn,
    from_json: $$let$7.from_json
  })
]));

function merge$19(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$9, t1.kkm, t2.kkm)
  };
}

function spec$19(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$19 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$19(undefined));
});

function to_proto$p$19(writer, param) {
  Curry._2(serialize$19, writer, param.kkm);
}

function to_proto$19(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$19(writer, t);
  return writer;
}

function constructor$38(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$19 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$19(undefined), constructor$38);
});

function from_proto$19(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$19, writer);
  });
}

function to_json$19(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ChangeRegisterKkmResponse", spec$19(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$39(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$19 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ChangeRegisterKkmResponse", spec$19(undefined), constructor$39);
});

function from_json$19(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$19, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ChangeRegisterKkmResponse, {
  make: make$19,
  to_proto: to_proto$19,
  from_proto: from_proto$19,
  to_json: to_json$19,
  from_json: from_json$19,
  name: name$19,
  merge: merge$19,
  to_proto$p: to_proto$p$19,
  from_proto_exn: from_proto_exn$19,
  from_json_exn: from_json_exn$19
});

function name$20(param) {
  return ".buhta.kassa.v1alpha1.KkmInisData";
}

function make$20(administrative_area_codeOpt, locality_codeOpt, sublocality_code, katoOpt, address_streetOpt, address_street1Opt, address_street2, param) {
  const administrative_area_code = administrative_area_codeOpt !== undefined ? administrative_area_codeOpt : "";
  const locality_code = locality_codeOpt !== undefined ? locality_codeOpt : "";
  const kato = katoOpt !== undefined ? katoOpt : "";
  const address_street = address_streetOpt !== undefined ? address_streetOpt : "";
  const address_street1 = address_street1Opt !== undefined ? address_street1Opt : "";
  return {
    administrative_area_code: administrative_area_code,
    locality_code: locality_code,
    sublocality_code: sublocality_code,
    kato: kato,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2
  };
}

const merge_administrative_area_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "administrative_area_code",
    "administrativeAreaCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_locality_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "locality_code",
    "localityCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_sublocality_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "sublocality_code",
    "sublocalityCode"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_kato = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "kato",
    "kato"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "address_street",
    "addressStreet"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "address_street1",
    "addressStreet1"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    7,
    "address_street2",
    "addressStreet2"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

function merge$20(t1, t2) {
  return {
    administrative_area_code: Curry._2(merge_administrative_area_code, t1.administrative_area_code, t2.administrative_area_code),
    locality_code: Curry._2(merge_locality_code, t1.locality_code, t2.locality_code),
    sublocality_code: Curry._2(merge_sublocality_code, t1.sublocality_code, t2.sublocality_code),
    kato: Curry._2(merge_kato, t1.kato, t2.kato),
    address_street: Curry._2(merge_address_street, t1.address_street, t2.address_street),
    address_street1: Curry._2(merge_address_street1, t1.address_street1, t2.address_street1),
    address_street2: Curry._2(merge_address_street2, t1.address_street2, t2.address_street2)
  };
}

function spec$20(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "administrative_area_code",
      "administrativeAreaCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "locality_code",
      "localityCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "sublocality_code",
      "sublocalityCode"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "kato",
      "kato"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "address_street",
      "addressStreet"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "address_street1",
      "addressStreet1"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      7,
      "address_street2",
      "addressStreet2"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$20 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$20(undefined));
});

function to_proto$p$20(writer, param) {
  Curry._8(serialize$20, writer, param.administrative_area_code, param.locality_code, param.sublocality_code, param.kato, param.address_street, param.address_street1, param.address_street2);
}

function to_proto$20(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$20(writer, t);
  return writer;
}

function constructor$40(administrative_area_code, locality_code, sublocality_code, kato, address_street, address_street1, address_street2) {
  return {
    administrative_area_code: administrative_area_code,
    locality_code: locality_code,
    sublocality_code: sublocality_code,
    kato: kato,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2
  };
}

const from_proto_exn$20 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$20(undefined), constructor$40);
});

function from_proto$20(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$20, writer);
  });
}

function to_json$20(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.KkmInisData", spec$20(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.administrative_area_code, param.locality_code, param.sublocality_code, param.kato, param.address_street, param.address_street1, param.address_street2);
  };
}

function constructor$41(administrative_area_code, locality_code, sublocality_code, kato, address_street, address_street1, address_street2) {
  return {
    administrative_area_code: administrative_area_code,
    locality_code: locality_code,
    sublocality_code: sublocality_code,
    kato: kato,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2
  };
}

const from_json_exn$20 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.KkmInisData", spec$20(undefined), constructor$41);
});

function from_json$20(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$20, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmInisData, {
  make: make$20,
  to_proto: to_proto$20,
  from_proto: from_proto$20,
  to_json: to_json$20,
  from_json: from_json$20,
  name: name$20,
  merge: merge$20,
  to_proto$p: to_proto$p$20,
  from_proto_exn: from_proto_exn$20,
  from_json_exn: from_json_exn$20
});

const KkmUnregisterData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5231,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$21(param) {
  return ".buhta.kassa.v1alpha1.UnregisterKkmRequest.KkmUnregisterData";
}

function make$21(unregister_reason_codeOpt, param) {
  const unregister_reason_code = unregister_reason_codeOpt !== undefined ? unregister_reason_codeOpt : "";
  return {
    unregister_reason_code: unregister_reason_code
  };
}

const merge_unregister_reason_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "unregister_reason_code",
    "unregisterReasonCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$21(t1, t2) {
  return {
    unregister_reason_code: Curry._2(merge_unregister_reason_code, t1.unregister_reason_code, t2.unregister_reason_code)
  };
}

function spec$21(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "unregister_reason_code",
      "unregisterReasonCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$21 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$21(undefined));
});

function to_proto$p$21(writer, param) {
  Curry._2(serialize$21, writer, param.unregister_reason_code);
}

function to_proto$21(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$21(writer, t);
  return writer;
}

function constructor$42(unregister_reason_code) {
  return {
    unregister_reason_code: unregister_reason_code
  };
}

const from_proto_exn$21 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$21(undefined), constructor$42);
});

function from_proto$21(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$21, writer);
  });
}

function to_json$21(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UnregisterKkmRequest.KkmUnregisterData", spec$21(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.unregister_reason_code);
  };
}

function constructor$43(unregister_reason_code) {
  return {
    unregister_reason_code: unregister_reason_code
  };
}

const from_json_exn$21 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UnregisterKkmRequest.KkmUnregisterData", spec$21(undefined), constructor$43);
});

function from_json$21(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$21, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmUnregisterData, {
  make: make$21,
  to_proto: to_proto$21,
  from_proto: from_proto$21,
  to_json: to_json$21,
  from_json: from_json$21,
  name: name$21,
  merge: merge$21,
  to_proto$p: to_proto$p$21,
  from_proto_exn: from_proto_exn$21,
  from_json_exn: from_json_exn$21
});

function name$22(param) {
  return ".buhta.kassa.v1alpha1.UnregisterKkmRequest";
}

function make$22(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$6 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$10 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmUnregisterData.name,
    make: KkmUnregisterData.make,
    from_proto: KkmUnregisterData.from_proto,
    from_proto_exn: KkmUnregisterData.from_proto_exn,
    to_proto: KkmUnregisterData.to_proto,
    to_proto$p: KkmUnregisterData.to_proto$p,
    merge: KkmUnregisterData.merge,
    to_json: KkmUnregisterData.to_json,
    from_json_exn: KkmUnregisterData.from_json_exn,
    from_json: KkmUnregisterData.from_json
  })
]));

function merge$22(t1, t2) {
  return {
    id: Curry._2(merge_id$6, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$10, t1.kkm, t2.kkm)
  };
}

function spec$22(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmUnregisterData.name,
      make: KkmUnregisterData.make,
      from_proto: KkmUnregisterData.from_proto,
      from_proto_exn: KkmUnregisterData.from_proto_exn,
      to_proto: KkmUnregisterData.to_proto,
      to_proto$p: KkmUnregisterData.to_proto$p,
      merge: KkmUnregisterData.merge,
      to_json: KkmUnregisterData.to_json,
      from_json_exn: KkmUnregisterData.from_json_exn,
      from_json: KkmUnregisterData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$22 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$22(undefined));
});

function to_proto$p$22(writer, param) {
  Curry._3(serialize$22, writer, param.id, param.kkm);
}

function to_proto$22(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$22(writer, t);
  return writer;
}

function constructor$44(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$22 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$22(undefined), constructor$44);
});

function from_proto$22(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$22, writer);
  });
}

function to_json$22(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UnregisterKkmRequest", spec$22(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$45(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$22 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UnregisterKkmRequest", spec$22(undefined), constructor$45);
});

function from_json$22(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$22, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmUnregisterData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UnregisterKkmRequest, {
  KkmUnregisterData: KkmUnregisterData,
  make: make$22,
  to_proto: to_proto$22,
  from_proto: from_proto$22,
  to_json: to_json$22,
  from_json: from_json$22,
  name: name$22,
  merge: merge$22,
  to_proto$p: to_proto$p$22,
  from_proto_exn: from_proto_exn$22,
  from_json_exn: from_json_exn$22
});

function name$23(param) {
  return ".buhta.kassa.v1alpha1.UnregisterKkmResponse";
}

function make$23(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$8 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$11 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$8.name,
    make: $$let$8.make,
    from_proto: $$let$8.from_proto,
    from_proto_exn: $$let$8.from_proto_exn,
    to_proto: $$let$8.to_proto,
    to_proto$p: $$let$8.to_proto$p,
    merge: $$let$8.merge,
    to_json: $$let$8.to_json,
    from_json_exn: $$let$8.from_json_exn,
    from_json: $$let$8.from_json
  })
]));

function merge$23(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$11, t1.kkm, t2.kkm)
  };
}

function spec$23(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$23 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$23(undefined));
});

function to_proto$p$23(writer, param) {
  Curry._2(serialize$23, writer, param.kkm);
}

function to_proto$23(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$23(writer, t);
  return writer;
}

function constructor$46(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$23 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$23(undefined), constructor$46);
});

function from_proto$23(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$23, writer);
  });
}

function to_json$23(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UnregisterKkmResponse", spec$23(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$47(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$23 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UnregisterKkmResponse", spec$23(undefined), constructor$47);
});

function from_json$23(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$23, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UnregisterKkmResponse, {
  make: make$23,
  to_proto: to_proto$23,
  from_proto: from_proto$23,
  to_json: to_json$23,
  from_json: from_json$23,
  name: name$23,
  merge: merge$23,
  to_proto$p: to_proto$p$23,
  from_proto_exn: from_proto_exn$23,
  from_json_exn: from_json_exn$23
});

const KkmLinkData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5445,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$24(param) {
  return ".buhta.kassa.v1alpha1.LinkKkmRequest.KkmLinkData";
}

function make$24(credentials, param) {
  return {
    credentials: credentials
  };
}

const merge_credentials = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "credentials",
    "credentials"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: OfdCredentials.name,
    make: OfdCredentials.make,
    from_proto: OfdCredentials.from_proto,
    from_proto_exn: OfdCredentials.from_proto_exn,
    to_proto: OfdCredentials.to_proto,
    to_proto$p: OfdCredentials.to_proto$p,
    merge: OfdCredentials.merge,
    to_json: OfdCredentials.to_json,
    from_json_exn: OfdCredentials.from_json_exn,
    from_json: OfdCredentials.from_json
  })
]));

function merge$24(t1, t2) {
  return {
    credentials: Curry._2(merge_credentials, t1.credentials, t2.credentials)
  };
}

function spec$24(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "credentials",
      "credentials"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: OfdCredentials.name,
      make: OfdCredentials.make,
      from_proto: OfdCredentials.from_proto,
      from_proto_exn: OfdCredentials.from_proto_exn,
      to_proto: OfdCredentials.to_proto,
      to_proto$p: OfdCredentials.to_proto$p,
      merge: OfdCredentials.merge,
      to_json: OfdCredentials.to_json,
      from_json_exn: OfdCredentials.from_json_exn,
      from_json: OfdCredentials.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$24 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$24(undefined));
});

function to_proto$p$24(writer, param) {
  Curry._2(serialize$24, writer, param.credentials);
}

function to_proto$24(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$24(writer, t);
  return writer;
}

function constructor$48(credentials) {
  return {
    credentials: credentials
  };
}

const from_proto_exn$24 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$24(undefined), constructor$48);
});

function from_proto$24(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$24, writer);
  });
}

function to_json$24(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.LinkKkmRequest.KkmLinkData", spec$24(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credentials);
  };
}

function constructor$49(credentials) {
  return {
    credentials: credentials
  };
}

const from_json_exn$24 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.LinkKkmRequest.KkmLinkData", spec$24(undefined), constructor$49);
});

function from_json$24(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$24, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmLinkData, {
  make: make$24,
  to_proto: to_proto$24,
  from_proto: from_proto$24,
  to_json: to_json$24,
  from_json: from_json$24,
  name: name$24,
  merge: merge$24,
  to_proto$p: to_proto$p$24,
  from_proto_exn: from_proto_exn$24,
  from_json_exn: from_json_exn$24
});

function name$25(param) {
  return ".buhta.kassa.v1alpha1.LinkKkmRequest";
}

function make$25(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$7 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$12 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmLinkData.name,
    make: KkmLinkData.make,
    from_proto: KkmLinkData.from_proto,
    from_proto_exn: KkmLinkData.from_proto_exn,
    to_proto: KkmLinkData.to_proto,
    to_proto$p: KkmLinkData.to_proto$p,
    merge: KkmLinkData.merge,
    to_json: KkmLinkData.to_json,
    from_json_exn: KkmLinkData.from_json_exn,
    from_json: KkmLinkData.from_json
  })
]));

function merge$25(t1, t2) {
  return {
    id: Curry._2(merge_id$7, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$12, t1.kkm, t2.kkm)
  };
}

function spec$25(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmLinkData.name,
      make: KkmLinkData.make,
      from_proto: KkmLinkData.from_proto,
      from_proto_exn: KkmLinkData.from_proto_exn,
      to_proto: KkmLinkData.to_proto,
      to_proto$p: KkmLinkData.to_proto$p,
      merge: KkmLinkData.merge,
      to_json: KkmLinkData.to_json,
      from_json_exn: KkmLinkData.from_json_exn,
      from_json: KkmLinkData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$25 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$25(undefined));
});

function to_proto$p$25(writer, param) {
  Curry._3(serialize$25, writer, param.id, param.kkm);
}

function to_proto$25(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$25(writer, t);
  return writer;
}

function constructor$50(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$25 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$25(undefined), constructor$50);
});

function from_proto$25(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$25, writer);
  });
}

function to_json$25(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.LinkKkmRequest", spec$25(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$51(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$25 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.LinkKkmRequest", spec$25(undefined), constructor$51);
});

function from_json$25(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$25, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, LinkKkmRequest, {
  KkmLinkData: KkmLinkData,
  make: make$25,
  to_proto: to_proto$25,
  from_proto: from_proto$25,
  to_json: to_json$25,
  from_json: from_json$25,
  name: name$25,
  merge: merge$25,
  to_proto$p: to_proto$p$25,
  from_proto_exn: from_proto_exn$25,
  from_json_exn: from_json_exn$25
});

function name$26(param) {
  return ".buhta.kassa.v1alpha1.LinkKkmResponse";
}

function make$26(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$9 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$13 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$9.name,
    make: $$let$9.make,
    from_proto: $$let$9.from_proto,
    from_proto_exn: $$let$9.from_proto_exn,
    to_proto: $$let$9.to_proto,
    to_proto$p: $$let$9.to_proto$p,
    merge: $$let$9.merge,
    to_json: $$let$9.to_json,
    from_json_exn: $$let$9.from_json_exn,
    from_json: $$let$9.from_json
  })
]));

function merge$26(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$13, t1.kkm, t2.kkm)
  };
}

function spec$26(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$26 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$26(undefined));
});

function to_proto$p$26(writer, param) {
  Curry._2(serialize$26, writer, param.kkm);
}

function to_proto$26(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$26(writer, t);
  return writer;
}

function constructor$52(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$26 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$26(undefined), constructor$52);
});

function from_proto$26(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$26, writer);
  });
}

function to_json$26(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.LinkKkmResponse", spec$26(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$53(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$26 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.LinkKkmResponse", spec$26(undefined), constructor$53);
});

function from_json$26(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$26, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, LinkKkmResponse, {
  make: make$26,
  to_proto: to_proto$26,
  from_proto: from_proto$26,
  to_json: to_json$26,
  from_json: from_json$26,
  name: name$26,
  merge: merge$26,
  to_proto$p: to_proto$p$26,
  from_proto_exn: from_proto_exn$26,
  from_json_exn: from_json_exn$26
});

function name$27(param) {
  return ".buhta.kassa.v1alpha1.ActivateKkmRequest";
}

function make$27(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id
  };
}

const merge_id$8 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

function merge$27(t1, t2) {
  return {
    id: Curry._2(merge_id$8, t1.id, t2.id)
  };
}

function spec$27(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$27 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$27(undefined));
});

function to_proto$p$27(writer, param) {
  Curry._2(serialize$27, writer, param.id);
}

function to_proto$27(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$27(writer, t);
  return writer;
}

function constructor$54(id) {
  return {
    id: id
  };
}

const from_proto_exn$27 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$27(undefined), constructor$54);
});

function from_proto$27(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$27, writer);
  });
}

function to_json$27(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ActivateKkmRequest", spec$27(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$55(id) {
  return {
    id: id
  };
}

const from_json_exn$27 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ActivateKkmRequest", spec$27(undefined), constructor$55);
});

function from_json$27(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$27, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ActivateKkmRequest, {
  make: make$27,
  to_proto: to_proto$27,
  from_proto: from_proto$27,
  to_json: to_json$27,
  from_json: from_json$27,
  name: name$27,
  merge: merge$27,
  to_proto$p: to_proto$p$27,
  from_proto_exn: from_proto_exn$27,
  from_json_exn: from_json_exn$27
});

function name$28(param) {
  return ".buhta.kassa.v1alpha1.ActivateKkmResponse";
}

function make$28(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$10 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$14 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$10.name,
    make: $$let$10.make,
    from_proto: $$let$10.from_proto,
    from_proto_exn: $$let$10.from_proto_exn,
    to_proto: $$let$10.to_proto,
    to_proto$p: $$let$10.to_proto$p,
    merge: $$let$10.merge,
    to_json: $$let$10.to_json,
    from_json_exn: $$let$10.from_json_exn,
    from_json: $$let$10.from_json
  })
]));

function merge$28(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$14, t1.kkm, t2.kkm)
  };
}

function spec$28(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$28 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$28(undefined));
});

function to_proto$p$28(writer, param) {
  Curry._2(serialize$28, writer, param.kkm);
}

function to_proto$28(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$28(writer, t);
  return writer;
}

function constructor$56(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$28 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$28(undefined), constructor$56);
});

function from_proto$28(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$28, writer);
  });
}

function to_json$28(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ActivateKkmResponse", spec$28(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$57(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$28 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ActivateKkmResponse", spec$28(undefined), constructor$57);
});

function from_json$28(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$28, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ActivateKkmResponse, {
  make: make$28,
  to_proto: to_proto$28,
  from_proto: from_proto$28,
  to_json: to_json$28,
  from_json: from_json$28,
  name: name$28,
  merge: merge$28,
  to_proto$p: to_proto$p$28,
  from_proto_exn: from_proto_exn$28,
  from_json_exn: from_json_exn$28
});

const KkmConnectData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.ml",
  5779,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$29(param) {
  return ".buhta.kassa.v1alpha1.ConnectKkmRequest.KkmConnectData";
}

function make$29(credentials, param) {
  return {
    credentials: credentials
  };
}

const merge_credentials$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "credentials",
    "credentials"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: OfdCredentials.name,
    make: OfdCredentials.make,
    from_proto: OfdCredentials.from_proto,
    from_proto_exn: OfdCredentials.from_proto_exn,
    to_proto: OfdCredentials.to_proto,
    to_proto$p: OfdCredentials.to_proto$p,
    merge: OfdCredentials.merge,
    to_json: OfdCredentials.to_json,
    from_json_exn: OfdCredentials.from_json_exn,
    from_json: OfdCredentials.from_json
  })
]));

function merge$29(t1, t2) {
  return {
    credentials: Curry._2(merge_credentials$1, t1.credentials, t2.credentials)
  };
}

function spec$29(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "credentials",
      "credentials"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: OfdCredentials.name,
      make: OfdCredentials.make,
      from_proto: OfdCredentials.from_proto,
      from_proto_exn: OfdCredentials.from_proto_exn,
      to_proto: OfdCredentials.to_proto,
      to_proto$p: OfdCredentials.to_proto$p,
      merge: OfdCredentials.merge,
      to_json: OfdCredentials.to_json,
      from_json_exn: OfdCredentials.from_json_exn,
      from_json: OfdCredentials.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$29 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$29(undefined));
});

function to_proto$p$29(writer, param) {
  Curry._2(serialize$29, writer, param.credentials);
}

function to_proto$29(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$29(writer, t);
  return writer;
}

function constructor$58(credentials) {
  return {
    credentials: credentials
  };
}

const from_proto_exn$29 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$29(undefined), constructor$58);
});

function from_proto$29(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$29, writer);
  });
}

function to_json$29(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ConnectKkmRequest.KkmConnectData", spec$29(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credentials);
  };
}

function constructor$59(credentials) {
  return {
    credentials: credentials
  };
}

const from_json_exn$29 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ConnectKkmRequest.KkmConnectData", spec$29(undefined), constructor$59);
});

function from_json$29(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$29, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmConnectData, {
  make: make$29,
  to_proto: to_proto$29,
  from_proto: from_proto$29,
  to_json: to_json$29,
  from_json: from_json$29,
  name: name$29,
  merge: merge$29,
  to_proto$p: to_proto$p$29,
  from_proto_exn: from_proto_exn$29,
  from_json_exn: from_json_exn$29
});

function name$30(param) {
  return ".buhta.kassa.v1alpha1.ConnectKkmRequest";
}

function make$30(idOpt, kkm, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    kkm: kkm
  };
}

const merge_id$9 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_kkm$15 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmConnectData.name,
    make: KkmConnectData.make,
    from_proto: KkmConnectData.from_proto,
    from_proto_exn: KkmConnectData.from_proto_exn,
    to_proto: KkmConnectData.to_proto,
    to_proto$p: KkmConnectData.to_proto$p,
    merge: KkmConnectData.merge,
    to_json: KkmConnectData.to_json,
    from_json_exn: KkmConnectData.from_json_exn,
    from_json: KkmConnectData.from_json
  })
]));

function merge$30(t1, t2) {
  return {
    id: Curry._2(merge_id$9, t1.id, t2.id),
    kkm: Curry._2(merge_kkm$15, t1.kkm, t2.kkm)
  };
}

function spec$30(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmConnectData.name,
      make: KkmConnectData.make,
      from_proto: KkmConnectData.from_proto,
      from_proto_exn: KkmConnectData.from_proto_exn,
      to_proto: KkmConnectData.to_proto,
      to_proto$p: KkmConnectData.to_proto$p,
      merge: KkmConnectData.merge,
      to_json: KkmConnectData.to_json,
      from_json_exn: KkmConnectData.from_json_exn,
      from_json: KkmConnectData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$30 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$30(undefined));
});

function to_proto$p$30(writer, param) {
  Curry._3(serialize$30, writer, param.id, param.kkm);
}

function to_proto$30(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$30(writer, t);
  return writer;
}

function constructor$60(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_proto_exn$30 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$30(undefined), constructor$60);
});

function from_proto$30(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$30, writer);
  });
}

function to_json$30(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ConnectKkmRequest", spec$30(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.kkm);
  };
}

function constructor$61(id, kkm) {
  return {
    id: id,
    kkm: kkm
  };
}

const from_json_exn$30 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ConnectKkmRequest", spec$30(undefined), constructor$61);
});

function from_json$30(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$30, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmConnectData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ConnectKkmRequest, {
  KkmConnectData: KkmConnectData,
  make: make$30,
  to_proto: to_proto$30,
  from_proto: from_proto$30,
  to_json: to_json$30,
  from_json: from_json$30,
  name: name$30,
  merge: merge$30,
  to_proto$p: to_proto$p$30,
  from_proto_exn: from_proto_exn$30,
  from_json_exn: from_json_exn$30
});

function name$31(param) {
  return ".buhta.kassa.v1alpha1.ConnectKkmResponse";
}

function make$31(kkm, param) {
  return {
    kkm: kkm
  };
}

const $$let$11 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkm$16 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "kkm",
    "kkm"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$11.name,
    make: $$let$11.make,
    from_proto: $$let$11.from_proto,
    from_proto_exn: $$let$11.from_proto_exn,
    to_proto: $$let$11.to_proto,
    to_proto$p: $$let$11.to_proto$p,
    merge: $$let$11.merge,
    to_json: $$let$11.to_json,
    from_json_exn: $$let$11.from_json_exn,
    from_json: $$let$11.from_json
  })
]));

function merge$31(t1, t2) {
  return {
    kkm: Curry._2(merge_kkm$16, t1.kkm, t2.kkm)
  };
}

function spec$31(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "kkm",
      "kkm"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$31 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$31(undefined));
});

function to_proto$p$31(writer, param) {
  Curry._2(serialize$31, writer, param.kkm);
}

function to_proto$31(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$31(writer, t);
  return writer;
}

function constructor$62(kkm) {
  return {
    kkm: kkm
  };
}

const from_proto_exn$31 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$31(undefined), constructor$62);
});

function from_proto$31(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$31, writer);
  });
}

function to_json$31(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ConnectKkmResponse", spec$31(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm);
  };
}

function constructor$63(kkm) {
  return {
    kkm: kkm
  };
}

const from_json_exn$31 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ConnectKkmResponse", spec$31(undefined), constructor$63);
});

function from_json$31(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$31, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ConnectKkmResponse, {
  make: make$31,
  to_proto: to_proto$31,
  from_proto: from_proto$31,
  to_json: to_json$31,
  from_json: from_json$31,
  name: name$31,
  merge: merge$31,
  to_proto$p: to_proto$p$31,
  from_proto_exn: from_proto_exn$31,
  from_json_exn: from_json_exn$31
});

function name$32(param) {
  return ".buhta.kassa.v1alpha1.OfdCredentials";
}

function make$32(ofd_device_idOpt, ofd_device_tokenOpt, param) {
  const ofd_device_id = ofd_device_idOpt !== undefined ? ofd_device_idOpt : "";
  const ofd_device_token = ofd_device_tokenOpt !== undefined ? ofd_device_tokenOpt : "";
  return {
    ofd_device_id: ofd_device_id,
    ofd_device_token: ofd_device_token
  };
}

const merge_ofd_device_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "ofd_device_id",
    "ofdDeviceId"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_ofd_device_token = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "ofd_device_token",
    "ofdDeviceToken"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$32(t1, t2) {
  return {
    ofd_device_id: Curry._2(merge_ofd_device_id, t1.ofd_device_id, t2.ofd_device_id),
    ofd_device_token: Curry._2(merge_ofd_device_token, t1.ofd_device_token, t2.ofd_device_token)
  };
}

function spec$32(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "ofd_device_id",
      "ofdDeviceId"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "ofd_device_token",
      "ofdDeviceToken"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$32 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$32(undefined));
});

function to_proto$p$32(writer, param) {
  Curry._3(serialize$32, writer, param.ofd_device_id, param.ofd_device_token);
}

function to_proto$32(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$32(writer, t);
  return writer;
}

function constructor$64(ofd_device_id, ofd_device_token) {
  return {
    ofd_device_id: ofd_device_id,
    ofd_device_token: ofd_device_token
  };
}

const from_proto_exn$32 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$32(undefined), constructor$64);
});

function from_proto$32(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$32, writer);
  });
}

function to_json$32(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.OfdCredentials", spec$32(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.ofd_device_id, param.ofd_device_token);
  };
}

function constructor$65(ofd_device_id, ofd_device_token) {
  return {
    ofd_device_id: ofd_device_id,
    ofd_device_token: ofd_device_token
  };
}

const from_json_exn$32 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.OfdCredentials", spec$32(undefined), constructor$65);
});

function from_json$32(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$32, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, OfdCredentials, {
  make: make$32,
  to_proto: to_proto$32,
  from_proto: from_proto$32,
  to_json: to_json$32,
  from_json: from_json$32,
  name: name$32,
  merge: merge$32,
  to_proto$p: to_proto$p$32,
  from_proto_exn: from_proto_exn$32,
  from_json_exn: from_json_exn$32
});

function name$33(param) {
  return ".buhta.kassa.v1alpha1.DeleteKkmRequest";
}

function make$33(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id
  };
}

const merge_id$10 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

function merge$33(t1, t2) {
  return {
    id: Curry._2(merge_id$10, t1.id, t2.id)
  };
}

function spec$33(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$33 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$33(undefined));
});

function to_proto$p$33(writer, param) {
  Curry._2(serialize$33, writer, param.id);
}

function to_proto$33(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$33(writer, t);
  return writer;
}

function constructor$66(id) {
  return {
    id: id
  };
}

const from_proto_exn$33 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$33(undefined), constructor$66);
});

function from_proto$33(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$33, writer);
  });
}

function to_json$33(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.DeleteKkmRequest", spec$33(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$67(id) {
  return {
    id: id
  };
}

const from_json_exn$33 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.DeleteKkmRequest", spec$33(undefined), constructor$67);
});

function from_json$33(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$33, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DeleteKkmRequest, {
  make: make$33,
  to_proto: to_proto$33,
  from_proto: from_proto$33,
  to_json: to_json$33,
  from_json: from_json$33,
  name: name$33,
  merge: merge$33,
  to_proto$p: to_proto$p$33,
  from_proto_exn: from_proto_exn$33,
  from_json_exn: from_json_exn$33
});

function name$34(param) {
  return ".buhta.kassa.v1alpha1.DeleteKkmResponse";
}

function make$34(param) {
  
}

function merge$34(param, param$1) {
  
}

const serialize$34 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$34(writer, param) {
  Curry._1(serialize$34, writer);
}

function to_proto$34(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$34, writer);
  return writer;
}

const from_proto_exn$34 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$34(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$34, writer);
  });
}

function to_json$34(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.DeleteKkmResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$34 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.DeleteKkmResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$34(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$34, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DeleteKkmResponse, {
  make: make$34,
  to_proto: to_proto$34,
  from_proto: from_proto$34,
  to_json: to_json$34,
  from_json: from_json$34,
  name: name$34,
  merge: merge$34,
  to_proto$p: to_proto$p$34,
  from_proto_exn: from_proto_exn$34,
  from_json_exn: from_json_exn$34
});

const getKkm_0 = {
  name: GetKkmRequest.name,
  make: GetKkmRequest.make,
  from_proto: GetKkmRequest.from_proto,
  from_proto_exn: GetKkmRequest.from_proto_exn,
  to_proto: GetKkmRequest.to_proto,
  to_proto$p: GetKkmRequest.to_proto$p,
  merge: GetKkmRequest.merge,
  to_json: GetKkmRequest.to_json,
  from_json_exn: GetKkmRequest.from_json_exn,
  from_json: GetKkmRequest.from_json
};

const getKkm_1 = {
  name: GetKkmResponse.name,
  make: GetKkmResponse.make,
  from_proto: GetKkmResponse.from_proto,
  from_proto_exn: GetKkmResponse.from_proto_exn,
  to_proto: GetKkmResponse.to_proto,
  to_proto$p: GetKkmResponse.to_proto$p,
  merge: GetKkmResponse.merge,
  to_json: GetKkmResponse.to_json,
  from_json_exn: GetKkmResponse.from_json_exn,
  from_json: GetKkmResponse.from_json
};

const getKkm = [
  getKkm_0,
  getKkm_1
];

const getRunningBalance_0 = {
  name: GetRunningBalanceRequest.name,
  make: GetRunningBalanceRequest.make,
  from_proto: GetRunningBalanceRequest.from_proto,
  from_proto_exn: GetRunningBalanceRequest.from_proto_exn,
  to_proto: GetRunningBalanceRequest.to_proto,
  to_proto$p: GetRunningBalanceRequest.to_proto$p,
  merge: GetRunningBalanceRequest.merge,
  to_json: GetRunningBalanceRequest.to_json,
  from_json_exn: GetRunningBalanceRequest.from_json_exn,
  from_json: GetRunningBalanceRequest.from_json
};

const getRunningBalance_1 = {
  name: GetRunningBalanceResponse.name,
  make: GetRunningBalanceResponse.make,
  from_proto: GetRunningBalanceResponse.from_proto,
  from_proto_exn: GetRunningBalanceResponse.from_proto_exn,
  to_proto: GetRunningBalanceResponse.to_proto,
  to_proto$p: GetRunningBalanceResponse.to_proto$p,
  merge: GetRunningBalanceResponse.merge,
  to_json: GetRunningBalanceResponse.to_json,
  from_json_exn: GetRunningBalanceResponse.from_json_exn,
  from_json: GetRunningBalanceResponse.from_json
};

const getRunningBalance = [
  getRunningBalance_0,
  getRunningBalance_1
];

const listKkms_0 = {
  name: ListKkmsRequest.name,
  make: ListKkmsRequest.make,
  from_proto: ListKkmsRequest.from_proto,
  from_proto_exn: ListKkmsRequest.from_proto_exn,
  to_proto: ListKkmsRequest.to_proto,
  to_proto$p: ListKkmsRequest.to_proto$p,
  merge: ListKkmsRequest.merge,
  to_json: ListKkmsRequest.to_json,
  from_json_exn: ListKkmsRequest.from_json_exn,
  from_json: ListKkmsRequest.from_json
};

const listKkms_1 = {
  name: ListKkmsResponse.name,
  make: ListKkmsResponse.make,
  from_proto: ListKkmsResponse.from_proto,
  from_proto_exn: ListKkmsResponse.from_proto_exn,
  to_proto: ListKkmsResponse.to_proto,
  to_proto$p: ListKkmsResponse.to_proto$p,
  merge: ListKkmsResponse.merge,
  to_json: ListKkmsResponse.to_json,
  from_json_exn: ListKkmsResponse.from_json_exn,
  from_json: ListKkmsResponse.from_json
};

const listKkms = [
  listKkms_0,
  listKkms_1
];

const createKkm_0 = {
  name: CreateKkmRequest.name,
  make: CreateKkmRequest.make,
  from_proto: CreateKkmRequest.from_proto,
  from_proto_exn: CreateKkmRequest.from_proto_exn,
  to_proto: CreateKkmRequest.to_proto,
  to_proto$p: CreateKkmRequest.to_proto$p,
  merge: CreateKkmRequest.merge,
  to_json: CreateKkmRequest.to_json,
  from_json_exn: CreateKkmRequest.from_json_exn,
  from_json: CreateKkmRequest.from_json
};

const createKkm_1 = {
  name: CreateKkmResponse.name,
  make: CreateKkmResponse.make,
  from_proto: CreateKkmResponse.from_proto,
  from_proto_exn: CreateKkmResponse.from_proto_exn,
  to_proto: CreateKkmResponse.to_proto,
  to_proto$p: CreateKkmResponse.to_proto$p,
  merge: CreateKkmResponse.merge,
  to_json: CreateKkmResponse.to_json,
  from_json_exn: CreateKkmResponse.from_json_exn,
  from_json: CreateKkmResponse.from_json
};

const createKkm = [
  createKkm_0,
  createKkm_1
];

const updateKkm_0 = {
  name: UpdateKkmRequest.name,
  make: UpdateKkmRequest.make,
  from_proto: UpdateKkmRequest.from_proto,
  from_proto_exn: UpdateKkmRequest.from_proto_exn,
  to_proto: UpdateKkmRequest.to_proto,
  to_proto$p: UpdateKkmRequest.to_proto$p,
  merge: UpdateKkmRequest.merge,
  to_json: UpdateKkmRequest.to_json,
  from_json_exn: UpdateKkmRequest.from_json_exn,
  from_json: UpdateKkmRequest.from_json
};

const updateKkm_1 = {
  name: UpdateKkmResponse.name,
  make: UpdateKkmResponse.make,
  from_proto: UpdateKkmResponse.from_proto,
  from_proto_exn: UpdateKkmResponse.from_proto_exn,
  to_proto: UpdateKkmResponse.to_proto,
  to_proto$p: UpdateKkmResponse.to_proto$p,
  merge: UpdateKkmResponse.merge,
  to_json: UpdateKkmResponse.to_json,
  from_json_exn: UpdateKkmResponse.from_json_exn,
  from_json: UpdateKkmResponse.from_json
};

const updateKkm = [
  updateKkm_0,
  updateKkm_1
];

const startKkm_0 = {
  name: StartKkmRequest.name,
  make: StartKkmRequest.make,
  from_proto: StartKkmRequest.from_proto,
  from_proto_exn: StartKkmRequest.from_proto_exn,
  to_proto: StartKkmRequest.to_proto,
  to_proto$p: StartKkmRequest.to_proto$p,
  merge: StartKkmRequest.merge,
  to_json: StartKkmRequest.to_json,
  from_json_exn: StartKkmRequest.from_json_exn,
  from_json: StartKkmRequest.from_json
};

const startKkm_1 = {
  name: StartKkmResponse.name,
  make: StartKkmResponse.make,
  from_proto: StartKkmResponse.from_proto,
  from_proto_exn: StartKkmResponse.from_proto_exn,
  to_proto: StartKkmResponse.to_proto,
  to_proto$p: StartKkmResponse.to_proto$p,
  merge: StartKkmResponse.merge,
  to_json: StartKkmResponse.to_json,
  from_json_exn: StartKkmResponse.from_json_exn,
  from_json: StartKkmResponse.from_json
};

const startKkm = [
  startKkm_0,
  startKkm_1
];

const registerKkm_0 = {
  name: RegisterKkmRequest.name,
  make: RegisterKkmRequest.make,
  from_proto: RegisterKkmRequest.from_proto,
  from_proto_exn: RegisterKkmRequest.from_proto_exn,
  to_proto: RegisterKkmRequest.to_proto,
  to_proto$p: RegisterKkmRequest.to_proto$p,
  merge: RegisterKkmRequest.merge,
  to_json: RegisterKkmRequest.to_json,
  from_json_exn: RegisterKkmRequest.from_json_exn,
  from_json: RegisterKkmRequest.from_json
};

const registerKkm_1 = {
  name: RegisterKkmResponse.name,
  make: RegisterKkmResponse.make,
  from_proto: RegisterKkmResponse.from_proto,
  from_proto_exn: RegisterKkmResponse.from_proto_exn,
  to_proto: RegisterKkmResponse.to_proto,
  to_proto$p: RegisterKkmResponse.to_proto$p,
  merge: RegisterKkmResponse.merge,
  to_json: RegisterKkmResponse.to_json,
  from_json_exn: RegisterKkmResponse.from_json_exn,
  from_json: RegisterKkmResponse.from_json
};

const registerKkm = [
  registerKkm_0,
  registerKkm_1
];

const changeRegisterKkm_0 = {
  name: ChangeRegisterKkmRequest.name,
  make: ChangeRegisterKkmRequest.make,
  from_proto: ChangeRegisterKkmRequest.from_proto,
  from_proto_exn: ChangeRegisterKkmRequest.from_proto_exn,
  to_proto: ChangeRegisterKkmRequest.to_proto,
  to_proto$p: ChangeRegisterKkmRequest.to_proto$p,
  merge: ChangeRegisterKkmRequest.merge,
  to_json: ChangeRegisterKkmRequest.to_json,
  from_json_exn: ChangeRegisterKkmRequest.from_json_exn,
  from_json: ChangeRegisterKkmRequest.from_json
};

const changeRegisterKkm_1 = {
  name: ChangeRegisterKkmResponse.name,
  make: ChangeRegisterKkmResponse.make,
  from_proto: ChangeRegisterKkmResponse.from_proto,
  from_proto_exn: ChangeRegisterKkmResponse.from_proto_exn,
  to_proto: ChangeRegisterKkmResponse.to_proto,
  to_proto$p: ChangeRegisterKkmResponse.to_proto$p,
  merge: ChangeRegisterKkmResponse.merge,
  to_json: ChangeRegisterKkmResponse.to_json,
  from_json_exn: ChangeRegisterKkmResponse.from_json_exn,
  from_json: ChangeRegisterKkmResponse.from_json
};

const changeRegisterKkm = [
  changeRegisterKkm_0,
  changeRegisterKkm_1
];

const unregisterKkm_0 = {
  name: UnregisterKkmRequest.name,
  make: UnregisterKkmRequest.make,
  from_proto: UnregisterKkmRequest.from_proto,
  from_proto_exn: UnregisterKkmRequest.from_proto_exn,
  to_proto: UnregisterKkmRequest.to_proto,
  to_proto$p: UnregisterKkmRequest.to_proto$p,
  merge: UnregisterKkmRequest.merge,
  to_json: UnregisterKkmRequest.to_json,
  from_json_exn: UnregisterKkmRequest.from_json_exn,
  from_json: UnregisterKkmRequest.from_json
};

const unregisterKkm_1 = {
  name: UnregisterKkmResponse.name,
  make: UnregisterKkmResponse.make,
  from_proto: UnregisterKkmResponse.from_proto,
  from_proto_exn: UnregisterKkmResponse.from_proto_exn,
  to_proto: UnregisterKkmResponse.to_proto,
  to_proto$p: UnregisterKkmResponse.to_proto$p,
  merge: UnregisterKkmResponse.merge,
  to_json: UnregisterKkmResponse.to_json,
  from_json_exn: UnregisterKkmResponse.from_json_exn,
  from_json: UnregisterKkmResponse.from_json
};

const unregisterKkm = [
  unregisterKkm_0,
  unregisterKkm_1
];

const linkKkm_0 = {
  name: LinkKkmRequest.name,
  make: LinkKkmRequest.make,
  from_proto: LinkKkmRequest.from_proto,
  from_proto_exn: LinkKkmRequest.from_proto_exn,
  to_proto: LinkKkmRequest.to_proto,
  to_proto$p: LinkKkmRequest.to_proto$p,
  merge: LinkKkmRequest.merge,
  to_json: LinkKkmRequest.to_json,
  from_json_exn: LinkKkmRequest.from_json_exn,
  from_json: LinkKkmRequest.from_json
};

const linkKkm_1 = {
  name: LinkKkmResponse.name,
  make: LinkKkmResponse.make,
  from_proto: LinkKkmResponse.from_proto,
  from_proto_exn: LinkKkmResponse.from_proto_exn,
  to_proto: LinkKkmResponse.to_proto,
  to_proto$p: LinkKkmResponse.to_proto$p,
  merge: LinkKkmResponse.merge,
  to_json: LinkKkmResponse.to_json,
  from_json_exn: LinkKkmResponse.from_json_exn,
  from_json: LinkKkmResponse.from_json
};

const linkKkm = [
  linkKkm_0,
  linkKkm_1
];

const activateKkm_0 = {
  name: ActivateKkmRequest.name,
  make: ActivateKkmRequest.make,
  from_proto: ActivateKkmRequest.from_proto,
  from_proto_exn: ActivateKkmRequest.from_proto_exn,
  to_proto: ActivateKkmRequest.to_proto,
  to_proto$p: ActivateKkmRequest.to_proto$p,
  merge: ActivateKkmRequest.merge,
  to_json: ActivateKkmRequest.to_json,
  from_json_exn: ActivateKkmRequest.from_json_exn,
  from_json: ActivateKkmRequest.from_json
};

const activateKkm_1 = {
  name: ActivateKkmResponse.name,
  make: ActivateKkmResponse.make,
  from_proto: ActivateKkmResponse.from_proto,
  from_proto_exn: ActivateKkmResponse.from_proto_exn,
  to_proto: ActivateKkmResponse.to_proto,
  to_proto$p: ActivateKkmResponse.to_proto$p,
  merge: ActivateKkmResponse.merge,
  to_json: ActivateKkmResponse.to_json,
  from_json_exn: ActivateKkmResponse.from_json_exn,
  from_json: ActivateKkmResponse.from_json
};

const activateKkm = [
  activateKkm_0,
  activateKkm_1
];

const connectKkm_0 = {
  name: ConnectKkmRequest.name,
  make: ConnectKkmRequest.make,
  from_proto: ConnectKkmRequest.from_proto,
  from_proto_exn: ConnectKkmRequest.from_proto_exn,
  to_proto: ConnectKkmRequest.to_proto,
  to_proto$p: ConnectKkmRequest.to_proto$p,
  merge: ConnectKkmRequest.merge,
  to_json: ConnectKkmRequest.to_json,
  from_json_exn: ConnectKkmRequest.from_json_exn,
  from_json: ConnectKkmRequest.from_json
};

const connectKkm_1 = {
  name: ConnectKkmResponse.name,
  make: ConnectKkmResponse.make,
  from_proto: ConnectKkmResponse.from_proto,
  from_proto_exn: ConnectKkmResponse.from_proto_exn,
  to_proto: ConnectKkmResponse.to_proto,
  to_proto$p: ConnectKkmResponse.to_proto$p,
  merge: ConnectKkmResponse.merge,
  to_json: ConnectKkmResponse.to_json,
  from_json_exn: ConnectKkmResponse.from_json_exn,
  from_json: ConnectKkmResponse.from_json
};

const connectKkm = [
  connectKkm_0,
  connectKkm_1
];

const deleteKkm_0 = {
  name: DeleteKkmRequest.name,
  make: DeleteKkmRequest.make,
  from_proto: DeleteKkmRequest.from_proto,
  from_proto_exn: DeleteKkmRequest.from_proto_exn,
  to_proto: DeleteKkmRequest.to_proto,
  to_proto$p: DeleteKkmRequest.to_proto$p,
  merge: DeleteKkmRequest.merge,
  to_json: DeleteKkmRequest.to_json,
  from_json_exn: DeleteKkmRequest.from_json_exn,
  from_json: DeleteKkmRequest.from_json
};

const deleteKkm_1 = {
  name: DeleteKkmResponse.name,
  make: DeleteKkmResponse.make,
  from_proto: DeleteKkmResponse.from_proto,
  from_proto_exn: DeleteKkmResponse.from_proto_exn,
  to_proto: DeleteKkmResponse.to_proto,
  to_proto$p: DeleteKkmResponse.to_proto$p,
  merge: DeleteKkmResponse.merge,
  to_json: DeleteKkmResponse.to_json,
  from_json_exn: DeleteKkmResponse.from_json_exn,
  from_json: DeleteKkmResponse.from_json
};

const deleteKkm = [
  deleteKkm_0,
  deleteKkm_1
];

const V1alpha1_KkmManagerService = {
  GetKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/GetKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "GetKkm",
    $$Request: {
      name: GetKkmRequest.name,
      make: GetKkmRequest.make,
      from_proto: GetKkmRequest.from_proto,
      from_proto_exn: GetKkmRequest.from_proto_exn,
      to_proto: GetKkmRequest.to_proto,
      to_proto$p: GetKkmRequest.to_proto$p,
      merge: GetKkmRequest.merge,
      to_json: GetKkmRequest.to_json,
      from_json_exn: GetKkmRequest.from_json_exn,
      from_json: GetKkmRequest.from_json
    },
    $$Response: {
      name: GetKkmResponse.name,
      make: GetKkmResponse.make,
      from_proto: GetKkmResponse.from_proto,
      from_proto_exn: GetKkmResponse.from_proto_exn,
      to_proto: GetKkmResponse.to_proto,
      to_proto$p: GetKkmResponse.to_proto$p,
      merge: GetKkmResponse.merge,
      to_json: GetKkmResponse.to_json,
      from_json_exn: GetKkmResponse.from_json_exn,
      from_json: GetKkmResponse.from_json
    }
  },
  getKkm: getKkm,
  GetRunningBalance: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/GetRunningBalance",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "GetRunningBalance",
    $$Request: {
      name: GetRunningBalanceRequest.name,
      make: GetRunningBalanceRequest.make,
      from_proto: GetRunningBalanceRequest.from_proto,
      from_proto_exn: GetRunningBalanceRequest.from_proto_exn,
      to_proto: GetRunningBalanceRequest.to_proto,
      to_proto$p: GetRunningBalanceRequest.to_proto$p,
      merge: GetRunningBalanceRequest.merge,
      to_json: GetRunningBalanceRequest.to_json,
      from_json_exn: GetRunningBalanceRequest.from_json_exn,
      from_json: GetRunningBalanceRequest.from_json
    },
    $$Response: {
      name: GetRunningBalanceResponse.name,
      make: GetRunningBalanceResponse.make,
      from_proto: GetRunningBalanceResponse.from_proto,
      from_proto_exn: GetRunningBalanceResponse.from_proto_exn,
      to_proto: GetRunningBalanceResponse.to_proto,
      to_proto$p: GetRunningBalanceResponse.to_proto$p,
      merge: GetRunningBalanceResponse.merge,
      to_json: GetRunningBalanceResponse.to_json,
      from_json_exn: GetRunningBalanceResponse.from_json_exn,
      from_json: GetRunningBalanceResponse.from_json
    }
  },
  getRunningBalance: getRunningBalance,
  ListKkms: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/ListKkms",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "ListKkms",
    $$Request: {
      name: ListKkmsRequest.name,
      make: ListKkmsRequest.make,
      from_proto: ListKkmsRequest.from_proto,
      from_proto_exn: ListKkmsRequest.from_proto_exn,
      to_proto: ListKkmsRequest.to_proto,
      to_proto$p: ListKkmsRequest.to_proto$p,
      merge: ListKkmsRequest.merge,
      to_json: ListKkmsRequest.to_json,
      from_json_exn: ListKkmsRequest.from_json_exn,
      from_json: ListKkmsRequest.from_json
    },
    $$Response: {
      name: ListKkmsResponse.name,
      make: ListKkmsResponse.make,
      from_proto: ListKkmsResponse.from_proto,
      from_proto_exn: ListKkmsResponse.from_proto_exn,
      to_proto: ListKkmsResponse.to_proto,
      to_proto$p: ListKkmsResponse.to_proto$p,
      merge: ListKkmsResponse.merge,
      to_json: ListKkmsResponse.to_json,
      from_json_exn: ListKkmsResponse.from_json_exn,
      from_json: ListKkmsResponse.from_json
    }
  },
  listKkms: listKkms,
  CreateKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/CreateKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "CreateKkm",
    $$Request: {
      name: CreateKkmRequest.name,
      make: CreateKkmRequest.make,
      from_proto: CreateKkmRequest.from_proto,
      from_proto_exn: CreateKkmRequest.from_proto_exn,
      to_proto: CreateKkmRequest.to_proto,
      to_proto$p: CreateKkmRequest.to_proto$p,
      merge: CreateKkmRequest.merge,
      to_json: CreateKkmRequest.to_json,
      from_json_exn: CreateKkmRequest.from_json_exn,
      from_json: CreateKkmRequest.from_json
    },
    $$Response: {
      name: CreateKkmResponse.name,
      make: CreateKkmResponse.make,
      from_proto: CreateKkmResponse.from_proto,
      from_proto_exn: CreateKkmResponse.from_proto_exn,
      to_proto: CreateKkmResponse.to_proto,
      to_proto$p: CreateKkmResponse.to_proto$p,
      merge: CreateKkmResponse.merge,
      to_json: CreateKkmResponse.to_json,
      from_json_exn: CreateKkmResponse.from_json_exn,
      from_json: CreateKkmResponse.from_json
    }
  },
  createKkm: createKkm,
  UpdateKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/UpdateKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "UpdateKkm",
    $$Request: {
      name: UpdateKkmRequest.name,
      make: UpdateKkmRequest.make,
      from_proto: UpdateKkmRequest.from_proto,
      from_proto_exn: UpdateKkmRequest.from_proto_exn,
      to_proto: UpdateKkmRequest.to_proto,
      to_proto$p: UpdateKkmRequest.to_proto$p,
      merge: UpdateKkmRequest.merge,
      to_json: UpdateKkmRequest.to_json,
      from_json_exn: UpdateKkmRequest.from_json_exn,
      from_json: UpdateKkmRequest.from_json
    },
    $$Response: {
      name: UpdateKkmResponse.name,
      make: UpdateKkmResponse.make,
      from_proto: UpdateKkmResponse.from_proto,
      from_proto_exn: UpdateKkmResponse.from_proto_exn,
      to_proto: UpdateKkmResponse.to_proto,
      to_proto$p: UpdateKkmResponse.to_proto$p,
      merge: UpdateKkmResponse.merge,
      to_json: UpdateKkmResponse.to_json,
      from_json_exn: UpdateKkmResponse.from_json_exn,
      from_json: UpdateKkmResponse.from_json
    }
  },
  updateKkm: updateKkm,
  StartKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/StartKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "StartKkm",
    $$Request: {
      name: StartKkmRequest.name,
      make: StartKkmRequest.make,
      from_proto: StartKkmRequest.from_proto,
      from_proto_exn: StartKkmRequest.from_proto_exn,
      to_proto: StartKkmRequest.to_proto,
      to_proto$p: StartKkmRequest.to_proto$p,
      merge: StartKkmRequest.merge,
      to_json: StartKkmRequest.to_json,
      from_json_exn: StartKkmRequest.from_json_exn,
      from_json: StartKkmRequest.from_json
    },
    $$Response: {
      name: StartKkmResponse.name,
      make: StartKkmResponse.make,
      from_proto: StartKkmResponse.from_proto,
      from_proto_exn: StartKkmResponse.from_proto_exn,
      to_proto: StartKkmResponse.to_proto,
      to_proto$p: StartKkmResponse.to_proto$p,
      merge: StartKkmResponse.merge,
      to_json: StartKkmResponse.to_json,
      from_json_exn: StartKkmResponse.from_json_exn,
      from_json: StartKkmResponse.from_json
    }
  },
  startKkm: startKkm,
  RegisterKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/RegisterKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "RegisterKkm",
    $$Request: {
      name: RegisterKkmRequest.name,
      make: RegisterKkmRequest.make,
      from_proto: RegisterKkmRequest.from_proto,
      from_proto_exn: RegisterKkmRequest.from_proto_exn,
      to_proto: RegisterKkmRequest.to_proto,
      to_proto$p: RegisterKkmRequest.to_proto$p,
      merge: RegisterKkmRequest.merge,
      to_json: RegisterKkmRequest.to_json,
      from_json_exn: RegisterKkmRequest.from_json_exn,
      from_json: RegisterKkmRequest.from_json
    },
    $$Response: {
      name: RegisterKkmResponse.name,
      make: RegisterKkmResponse.make,
      from_proto: RegisterKkmResponse.from_proto,
      from_proto_exn: RegisterKkmResponse.from_proto_exn,
      to_proto: RegisterKkmResponse.to_proto,
      to_proto$p: RegisterKkmResponse.to_proto$p,
      merge: RegisterKkmResponse.merge,
      to_json: RegisterKkmResponse.to_json,
      from_json_exn: RegisterKkmResponse.from_json_exn,
      from_json: RegisterKkmResponse.from_json
    }
  },
  registerKkm: registerKkm,
  ChangeRegisterKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/ChangeRegisterKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "ChangeRegisterKkm",
    $$Request: {
      name: ChangeRegisterKkmRequest.name,
      make: ChangeRegisterKkmRequest.make,
      from_proto: ChangeRegisterKkmRequest.from_proto,
      from_proto_exn: ChangeRegisterKkmRequest.from_proto_exn,
      to_proto: ChangeRegisterKkmRequest.to_proto,
      to_proto$p: ChangeRegisterKkmRequest.to_proto$p,
      merge: ChangeRegisterKkmRequest.merge,
      to_json: ChangeRegisterKkmRequest.to_json,
      from_json_exn: ChangeRegisterKkmRequest.from_json_exn,
      from_json: ChangeRegisterKkmRequest.from_json
    },
    $$Response: {
      name: ChangeRegisterKkmResponse.name,
      make: ChangeRegisterKkmResponse.make,
      from_proto: ChangeRegisterKkmResponse.from_proto,
      from_proto_exn: ChangeRegisterKkmResponse.from_proto_exn,
      to_proto: ChangeRegisterKkmResponse.to_proto,
      to_proto$p: ChangeRegisterKkmResponse.to_proto$p,
      merge: ChangeRegisterKkmResponse.merge,
      to_json: ChangeRegisterKkmResponse.to_json,
      from_json_exn: ChangeRegisterKkmResponse.from_json_exn,
      from_json: ChangeRegisterKkmResponse.from_json
    }
  },
  changeRegisterKkm: changeRegisterKkm,
  UnregisterKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/UnregisterKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "UnregisterKkm",
    $$Request: {
      name: UnregisterKkmRequest.name,
      make: UnregisterKkmRequest.make,
      from_proto: UnregisterKkmRequest.from_proto,
      from_proto_exn: UnregisterKkmRequest.from_proto_exn,
      to_proto: UnregisterKkmRequest.to_proto,
      to_proto$p: UnregisterKkmRequest.to_proto$p,
      merge: UnregisterKkmRequest.merge,
      to_json: UnregisterKkmRequest.to_json,
      from_json_exn: UnregisterKkmRequest.from_json_exn,
      from_json: UnregisterKkmRequest.from_json
    },
    $$Response: {
      name: UnregisterKkmResponse.name,
      make: UnregisterKkmResponse.make,
      from_proto: UnregisterKkmResponse.from_proto,
      from_proto_exn: UnregisterKkmResponse.from_proto_exn,
      to_proto: UnregisterKkmResponse.to_proto,
      to_proto$p: UnregisterKkmResponse.to_proto$p,
      merge: UnregisterKkmResponse.merge,
      to_json: UnregisterKkmResponse.to_json,
      from_json_exn: UnregisterKkmResponse.from_json_exn,
      from_json: UnregisterKkmResponse.from_json
    }
  },
  unregisterKkm: unregisterKkm,
  LinkKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/LinkKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "LinkKkm",
    $$Request: {
      name: LinkKkmRequest.name,
      make: LinkKkmRequest.make,
      from_proto: LinkKkmRequest.from_proto,
      from_proto_exn: LinkKkmRequest.from_proto_exn,
      to_proto: LinkKkmRequest.to_proto,
      to_proto$p: LinkKkmRequest.to_proto$p,
      merge: LinkKkmRequest.merge,
      to_json: LinkKkmRequest.to_json,
      from_json_exn: LinkKkmRequest.from_json_exn,
      from_json: LinkKkmRequest.from_json
    },
    $$Response: {
      name: LinkKkmResponse.name,
      make: LinkKkmResponse.make,
      from_proto: LinkKkmResponse.from_proto,
      from_proto_exn: LinkKkmResponse.from_proto_exn,
      to_proto: LinkKkmResponse.to_proto,
      to_proto$p: LinkKkmResponse.to_proto$p,
      merge: LinkKkmResponse.merge,
      to_json: LinkKkmResponse.to_json,
      from_json_exn: LinkKkmResponse.from_json_exn,
      from_json: LinkKkmResponse.from_json
    }
  },
  linkKkm: linkKkm,
  ActivateKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/ActivateKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "ActivateKkm",
    $$Request: {
      name: ActivateKkmRequest.name,
      make: ActivateKkmRequest.make,
      from_proto: ActivateKkmRequest.from_proto,
      from_proto_exn: ActivateKkmRequest.from_proto_exn,
      to_proto: ActivateKkmRequest.to_proto,
      to_proto$p: ActivateKkmRequest.to_proto$p,
      merge: ActivateKkmRequest.merge,
      to_json: ActivateKkmRequest.to_json,
      from_json_exn: ActivateKkmRequest.from_json_exn,
      from_json: ActivateKkmRequest.from_json
    },
    $$Response: {
      name: ActivateKkmResponse.name,
      make: ActivateKkmResponse.make,
      from_proto: ActivateKkmResponse.from_proto,
      from_proto_exn: ActivateKkmResponse.from_proto_exn,
      to_proto: ActivateKkmResponse.to_proto,
      to_proto$p: ActivateKkmResponse.to_proto$p,
      merge: ActivateKkmResponse.merge,
      to_json: ActivateKkmResponse.to_json,
      from_json_exn: ActivateKkmResponse.from_json_exn,
      from_json: ActivateKkmResponse.from_json
    }
  },
  activateKkm: activateKkm,
  ConnectKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/ConnectKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "ConnectKkm",
    $$Request: {
      name: ConnectKkmRequest.name,
      make: ConnectKkmRequest.make,
      from_proto: ConnectKkmRequest.from_proto,
      from_proto_exn: ConnectKkmRequest.from_proto_exn,
      to_proto: ConnectKkmRequest.to_proto,
      to_proto$p: ConnectKkmRequest.to_proto$p,
      merge: ConnectKkmRequest.merge,
      to_json: ConnectKkmRequest.to_json,
      from_json_exn: ConnectKkmRequest.from_json_exn,
      from_json: ConnectKkmRequest.from_json
    },
    $$Response: {
      name: ConnectKkmResponse.name,
      make: ConnectKkmResponse.make,
      from_proto: ConnectKkmResponse.from_proto,
      from_proto_exn: ConnectKkmResponse.from_proto_exn,
      to_proto: ConnectKkmResponse.to_proto,
      to_proto$p: ConnectKkmResponse.to_proto$p,
      merge: ConnectKkmResponse.merge,
      to_json: ConnectKkmResponse.to_json,
      from_json_exn: ConnectKkmResponse.from_json_exn,
      from_json: ConnectKkmResponse.from_json
    }
  },
  connectKkm: connectKkm,
  DeleteKkm: {
    name: "/buhta.kassa.v1alpha1.KkmManagerService/DeleteKkm",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmManagerService",
    method_name: "DeleteKkm",
    $$Request: {
      name: DeleteKkmRequest.name,
      make: DeleteKkmRequest.make,
      from_proto: DeleteKkmRequest.from_proto,
      from_proto_exn: DeleteKkmRequest.from_proto_exn,
      to_proto: DeleteKkmRequest.to_proto,
      to_proto$p: DeleteKkmRequest.to_proto$p,
      merge: DeleteKkmRequest.merge,
      to_json: DeleteKkmRequest.to_json,
      from_json_exn: DeleteKkmRequest.from_json_exn,
      from_json: DeleteKkmRequest.from_json
    },
    $$Response: {
      name: DeleteKkmResponse.name,
      make: DeleteKkmResponse.make,
      from_proto: DeleteKkmResponse.from_proto,
      from_proto_exn: DeleteKkmResponse.from_proto_exn,
      to_proto: DeleteKkmResponse.to_proto,
      to_proto$p: DeleteKkmResponse.to_proto$p,
      merge: DeleteKkmResponse.merge,
      to_json: DeleteKkmResponse.to_json,
      from_json_exn: DeleteKkmResponse.from_json_exn,
      from_json: DeleteKkmResponse.from_json
    }
  },
  deleteKkm: deleteKkm
};

const V1alpha1 = {
  GetKkmRequest: GetKkmRequest,
  GetKkmResponse: GetKkmResponse,
  GetRunningBalanceRequest: GetRunningBalanceRequest,
  GetRunningBalanceResponse: GetRunningBalanceResponse,
  ListKkmsRequest: ListKkmsRequest,
  ListKkmsResponse: ListKkmsResponse,
  CreateKkmRequest: CreateKkmRequest,
  CreateKkmResponse: CreateKkmResponse,
  UpdateKkmRequest: UpdateKkmRequest,
  UpdateKkmResponse: UpdateKkmResponse,
  StartKkmRequest: StartKkmRequest,
  StartKkmResponse: StartKkmResponse,
  RegisterKkmRequest: RegisterKkmRequest,
  RegisterKkmResponse: RegisterKkmResponse,
  ChangeRegisterKkmRequest: ChangeRegisterKkmRequest,
  ChangeRegisterKkmResponse: ChangeRegisterKkmResponse,
  KkmInisData: KkmInisData,
  UnregisterKkmRequest: UnregisterKkmRequest,
  UnregisterKkmResponse: UnregisterKkmResponse,
  LinkKkmRequest: LinkKkmRequest,
  LinkKkmResponse: LinkKkmResponse,
  ActivateKkmRequest: ActivateKkmRequest,
  ActivateKkmResponse: ActivateKkmResponse,
  ConnectKkmRequest: ConnectKkmRequest,
  ConnectKkmResponse: ConnectKkmResponse,
  OfdCredentials: OfdCredentials,
  DeleteKkmRequest: DeleteKkmRequest,
  DeleteKkmResponse: DeleteKkmResponse,
  KkmManagerService: V1alpha1_KkmManagerService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules,
  Buhta,
}
/* GetKkmRequest Not a pure module */
